import constants from '#packages/constants';
import React from 'react';
import {
  POSITIONS,
  regularIllustrationNames,
  stripsAndColumnsIllustrationNames,
  type BorderPosition,
  type PositionType,
} from './borderPositionControl.constants';
import * as symbols from '@wix/santa-editor-symbols';

export function getBorderPositionIllustrationByCompType(
  position: PositionType,
  compType: string,
) {
  const isStripOrColumn =
    compType === constants.COMP_TYPES.COLUMN ||
    compType === constants.COMP_TYPES.STRIP_COLUMNS_CONTAINER;

  if (isStripOrColumn) {
    return stripsAndColumnsIllustrationNames[position];
  }

  return regularIllustrationNames[position];
}

export function getBorderPositions(compType: string): BorderPosition[] {
  return [
    {
      value: POSITIONS.none,
      illustration: React.createElement(symbols.symbol, {
        name: getBorderPositionIllustrationByCompType(POSITIONS.none, compType),
      }),

      label: 'CustomDesign_LangMenu_Border_Position_Label_None',
      dataHook: 'border-style-position-none',
    },
    {
      value: POSITIONS.full,
      illustration: React.createElement(symbols.symbol, {
        name: getBorderPositionIllustrationByCompType(POSITIONS.full, compType),
      }),
      label: 'CustomDesign_LangMenu_Border_Position_Label_Full',
      dataHook: 'border-style-position-full',
    },
    {
      value: POSITIONS.bottom,
      illustration: React.createElement(symbols.symbol, {
        name: getBorderPositionIllustrationByCompType(
          POSITIONS.bottom,
          compType,
        ),
      }),
      label: 'CustomDesign_LangMenu_Border_Position_Label_Bottom',
      dataHook: 'border-style-position-bottom',
    },
  ];
}
